import { INTEGRATION_PAGE_PATH } from 'application/consts';
import { RouterUtils } from 'application/providers/RouterProvider';

import { buildAbsoluteUrl } from '@shared/lib';

export const SBBOL_URI_FOR_RETURN = buildAbsoluteUrl(
  RouterUtils.generatePath(INTEGRATION_PAGE_PATH, { type: 'sbbol' })
);
